import http, { encode } from './index';

export const editBilling = async (company, values) => http.put(`/companies/${encode(company)}`, values);
